import * as React from 'react';

function SvgTrackProcessing() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.625 3.5625H2.375C2.06006 3.5625 1.75801 3.68761 1.53531 3.91031C1.31261 4.13301 1.1875 4.43506 1.1875 4.75V14.25C1.1875 14.5649 1.31261 14.867 1.53531 15.0897C1.75801 15.3124 2.06006 15.4375 2.375 15.4375H16.625C16.9399 15.4375 17.242 15.3124 17.4647 15.0897C17.6874 14.867 17.8125 14.5649 17.8125 14.25V4.75C17.8125 4.43506 17.6874 4.13301 17.4647 3.91031C17.242 3.68761 16.9399 3.5625 16.625 3.5625ZM16.625 4.75V6.53125H2.375V4.75H16.625ZM2.375 14.25V7.71875H16.625V14.25H2.375Z"
        fill="black" />
      <path d="M3.5625 11.875H9.5V13.0625H3.5625V11.875Z" fill="black" />
    </svg>

  );
}

export default SvgTrackProcessing;
